import isString from 'lodash/isString';
import { unwrapUeResponse } from '../../../../../../../utils/uwResponse';
import { fetchProvisionalFileStatement, getProvisionalFiles } from './service';
import { FetchProvisionalFileStatementParams, ProvisionalFileItem, ProvisionalFileStatementData } from './types';

export type ProvisionalFileListResult = { success: true; files: ProvisionalFileItem[] } | { success: false };
export type ProvisionalFileStatementResult = { success: true; data: ProvisionalFileStatementData } | { success: false };

/** An older list item lacks these fields, so it is dropped and the select degrades to "All files". */
export function isUsableFileItem(item: any): item is ProvisionalFileItem {
    return ['docId', 'displayName', 'viewStatus'].every((key) => isString(item?.[key]));
}

export async function fetchProvisionalFileList(orgId: string): Promise<ProvisionalFileListResult> {
    try {
        const result = unwrapUeResponse<ProvisionalFileItem[]>(await getProvisionalFiles(orgId));
        if (result.ok) return { success: true, files: (Array.isArray(result.data) ? result.data : []).filter(isUsableFileItem) };
    } catch {
        // Falls through to the single failure log below.
    }
    console.error('Provisional file list unavailable', { orgId });
    return { success: false };
}

export async function fetchProvisionalFileStatementData(
    params: FetchProvisionalFileStatementParams,
): Promise<ProvisionalFileStatementResult> {
    try {
        const result = unwrapUeResponse<ProvisionalFileStatementData>(await fetchProvisionalFileStatement(params));
        if (result.ok) return { success: true, data: result.data ?? {} };
    } catch {
        // Falls through to the failure result; the hook toasts.
    }
    return { success: false };
}
